import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [marginRight, setMarginRight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.025 * cardRef.current.clientWidth));
        setLineHeight(0.04 * cardRef.current.clientWidth);
        setLetterSpacing(0.004 * cardRef.current.clientWidth);
        setMarginRight(0.0 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: `${lineHeight}px`,
          marginRight: `${marginRight}px`,
          letterSpacing: `${letterSpacing}px`,
          textAlign: "center",
        }}
      >
        <p>and you</p>
        <p>tipping my hand</p>
        <p>to put even more water</p>
        <p>over that lost fire</p>
      </div>
    </div>
  );
}
